import { render } from "./foundationAuth.vue?vue&type=template&id=22a6e47c&scoped=true"
import script from "./foundationAuth.vue?vue&type=script&lang=js"
export * from "./foundationAuth.vue?vue&type=script&lang=js"

import "./foundationAuth.vue?vue&type=style&index=0&id=22a6e47c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a6e47c"]])

export default __exports__